module.exports = __webpack_public_path__ + "static/scale-model-of-burnside-fountain-in-worcester-massachusetts-295c33dbd43038837cd6eb115885aead.png";